import React, { Component } from 'react';
import styled from 'styled-components';
import Header from '../../components/Header';
import Kpi from '../../components/Kpi';
import Carousel from '../../components/Carousel';
import CarouselItem from './components/CarouselItem';
import TabNavigation from '../../components/TabNavigation';
import { connect } from 'react-redux';
import { getPrimeurHeader } from '../../actions/primeur';

import Spinner from '../../components/Spinner';
import WarningMessageSmallScreen from '../../components/WarningMessageSmallScreen';
import { I18n } from 'react-redux-i18n';

const DistributionContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: calc(100vw - 150px);
  padding: 20px;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    max-width: calc(100vw - 15px);
    padding: 16px;
  }

  .filters,
  .navigation {
    margin-top: 20px;
  }

  @media (min-width: 801px) {
    .surveyContent {
      line-height: 15px;
    }

    .pagination {
      margin-left: auto;
      margin-right: 13px;
      padding-left: 10px;
    }
  }

  .headerContainer {
    margin-top: 22px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  @media (max-width: 1200px) {
    .pagination {
      margin-right: auto;
    }

    .headerContainer {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .indicatorsContainer {
    background-color: ${(props) => props.theme.colors['terra-cotta']};
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
    min-height: 90px;
    width: 313px;
    min-width: 313px;
    justify-content: center;
    z-index: 1;
    border-radius: 4px;
  }

  .indicator {
    height: 60%;
    border-radius: 4px;
    padding: 8px 5px;
    width: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: solid 0.8px rgba(255, 255, 255, 0.75);
    background-color: transparent;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 13px;
    color: white;
    text-align: center;
  }

  .indicator:not(:last-child) {
    margin-right: 13px;
  }

  .indicatorValue {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    font-size: 20px;
  }

  .indicatorLabel {
    margin-top: 8px;
  }

  @media (max-width: 1200px) {
    .indicatorsContainer {
      width: 100%;
      justify-content: space-around;
      padding-left: 0px;
      padding-right: 0px;
    }
  }

  .rightFeedContainer {
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: white;
  }

  .feedClientWines {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 5px;
    margin-left: 10px;
  }

  .feedClientWines p {
    font-size: 12px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
  }
`;

class PrimeurCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      currentKpi: 0
    };
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    await this.props.getPrimeurHeader();
    this.setState({ loading: false });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps != this.props &&
      this.props.primeur.kpis &&
      this.props.primeur.kpis.length > 0
    ) {
      this.setState({
        currentKpi: Math.floor(Math.random() * this.props.primeur.kpis.length)
      });
    }
  }

  getNavigationOptions() {
    return [
      {
        label: I18n.t('primeur.navigationOptions.primeur'),
        route: '/distribution/primeur',
        active: true
      },
      {
        label: I18n.t('primeur.navigationOptions.preparation'),
        route: '/distribution/primeur/preparation',
        active: false
      },
      {
        label: I18n.t('primeur.navigationOptions.recap'),
        route: '/distribution/primeur/recap',
        active: false
      }
    ];
  }

  getRandomKpi() {
    const kpis = this.props.primeur.kpis || [];
    const { currentKpi } = this.state;
    if (kpis.length > 0) {
      return kpis[currentKpi];
    }
    return {
      wine_id: 1,
      wine_name: '',
      vintage: '',
      size: '',
      avg_dev: 0.0,
      avg_price: 0,
      pmm_price: 0
    };
  }

  render() {
    const navigationOptions = this.getNavigationOptions();
    const { feed } = this.props.primeur || [];
    const randomKpi = this.getRandomKpi();

    const kpis = this.props.primeur.kpis || [];
    const { currentKpi } = this.state;
    return (
      <DistributionContainer>
        <Header
          title={I18n.t('primeur.title')}
          subTitle={I18n.t('primeur.subTitle')}
        />
        <div className="headerContainer">
          <Kpi
            value={randomKpi.avg_price.toLocaleString('fr-FR', {
              style: 'currency',
              currency: 'EUR',
              minimumFractionDigits: 0,
              maximumFractionDigits: 1
            })}
            valueText={I18n.t('primeur.kpiValueText')}
            title={`${randomKpi.wine_name || ''} ${randomKpi.vintage || ''}`}
            subTitle={`${(randomKpi.avg_dev * 100).toLocaleString('fr-FR', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2
            })} ${I18n.t('primeur.kpiSubTitle')}`}
            handleNext={
              kpis && kpis.length > 1
                ? () =>
                    this.setState({
                      currentKpi:
                        currentKpi === kpis.length - 1 || kpis.length < 2
                          ? 0
                          : currentKpi + 1
                    })
                : undefined
            }
          />
          <Carousel ItemComponent={CarouselItem} data={feed} />
        </div>

        {window.innerWidth > 845 ? (
          <React.Fragment>
            <div className="navigation">
              <TabNavigation buttons={navigationOptions} />
            </div>
            {this.props.children}
          </React.Fragment>
        ) : (
          <WarningMessageSmallScreen />
        )}
        <Spinner loading={this.state.loading} />
      </DistributionContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    primeur: state.primeur
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPrimeurHeader: async () => {
      await dispatch(getPrimeurHeader());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrimeurCampaign);
